import type { Celebrity, PublicCelebrity } from "@pushup/types";
import { api, WITH_CREDENTIALS } from "@/lib/api";

/** Fetches the server-backed celebrity roster. Sends the session cookie. */
export function listCelebrities(): Promise<Celebrity[]> {
  return api.get<Celebrity[]>("/celebrities", WITH_CREDENTIALS);
}

/**
 * Fetches the read-only roster preview (id/name/image only) used by the
 * opponent circles. Open to everyone — it never carries coaching data.
 */
export function listPublicCelebrities(): Promise<PublicCelebrity[]> {
  return api.get<PublicCelebrity[]>("/celebrities/public", WITH_CREDENTIALS);
}
